<!-- TABLE Ở TRANG ADMIN -->
<nz-layout id="purchase-invoice-today">
  <!-- Phần header -->
  <div class="purchase-invoice-today-header">
    <div class="row p-0 m-0">
      <div class="col-6 p-0 m-0 d-flex align-items-center">
        <p class="title-admin">
          {{data.name}}
          <i class="bi bi-pencil-square ml-2" (click)="editNameObject(data)"></i>
        </p>
        <!-- Tìm kiếm -->
        <div class="search">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input placeholder="{{'tim_kiem_ten' | translate}} {{name_main_sector | translate}}" [(ngModel)]="searchNameObject"
              (keyup.enter)="onSearchBlock(searchNameObject)" />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span (click)="onSearchBlock(searchNameObject)" nz-icon nzType="search"></span>
          </ng-template>
        </div>
      </div>
      <!-- Nút thêm sản phẩm vào frame -->
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-end">
        <!-- Chọn ngôn ngữ -->
        <!-- <div class="mr-2">
          <app-select-language-config [isAdmin]="true"></app-select-language-config>
        </div> -->
        <button nzType="primary" class="_btn _btn_add d-flex align-items-center right-all-content mr-2" nz-button
          (click)="showModal()">
          {{ ('chon' | translate) + ' ' + (name_main_sector | translate) + ' ' + ('hien_thi_trong_khung_tu_chon' | translate) }}
        </button>
      </div>
    </div>
  </div>
  <!-- Phần table -->
  <div style="margin-top: 16px; height: 500px;">
    <nz-table #searchedObjectsTable nzShowSizeChanger 
      [nzScroll]="{ y: tableHeight }" 
      [nzData]="searchedObjects"
      [nzShowPagination]="false" 
      [nzFrontPagination]="false"
      [nzLoading]="loadingObject">
      <!-- table header -->
      <thead class="_thead">
        <tr>
          <th nzWidth="10%" nzAlign="center"><b>{{'anh' | translate}}</b></th>
          <th nzWidth="32.5%" nzAlign="left">
            <b>{{'ten' | translate}} {{name_main_sector | translate}}</b>
            <span nz-icon (click)="handleSortBlock()" [nzType]=" isASC ? 'arrow-down' : 'arrow-up'"
              nzTheme="outline"></span>
          </th>
          <th nzWidth="32.5%" nzAlign="left"> <b>{{'vi_tri_hien_thi' | translate}}</b></th>
          <th nzWidth="25%" nzAlign="center"><b>{{'chuc_nang' | translate}}</b></th>
        </tr>
      </thead>
      <!-- table body -->
      <tbody>
        <ng-container *ngFor="let item of searchedObjectsTable.data;">
          <tr >
            <td>
              <div class="image d-flex align-items-center justify-content-center">
                <img onerror="this.src='/assets/root/images/system/icons/image_default.svg'"
                  [src]="item.imgs? item.imgs[0] : ''" [alt]="(item['name_' + functionService.defaultLanguage] ?? '') || item.title" width="40px" height="40px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px; font-weight: 600;">
                <span>{{ (item['name_' + functionService.defaultLanguage] ?? '') || item.title }}</span>
              </div>
            </td>
            <td>
              <div class="status">
                <label class="switch">
                  <input type="number" class="input" min="1" [(ngModel)]="item[this.data._id+'_ordinal_number']"
                    (blur)="updateOrder(item, item[this.data._id+'_ordinal_number'])"
                    style="min-width: auto;height: 30px;">
                </label>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status">
                <label class="switch">
                  <button nz-button nzType="primary" (click)="updateShowWeb(item, false)">Gỡ bỏ</button>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    
    <!-- Pagination Block -->
    <div *ngIf="searchedObjects.length" class="pagination mt-3">
      <div class="pagination-list-button">
        <div class="page-start pagiItem" (click)="gotoPreviousPage()">{{'truoc' | translate }}</div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock >= 3 && pageCurrentBlock >= 3" (click)="transferFn(1)">
          1
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock > 3 && pageCurrentBlock > 3">
          ...
        </div>
        <div *ngFor='let page of pageShowChooseBlock ;let i = index'>
          <div class="page-number pagiItem" *ngIf="page <= totalPagesBlock && page > 0"
            [ngClass]="{'active': page == pageCurrentBlock}" (click)="transferFn(page)">
            {{page}}
          </div>
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock > 3 && pageCurrentBlock < totalPagesBlock-2">
          ...
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock >= 3 && pageCurrentBlock <= totalPagesBlock-2"
          (click)="transferFn(totalPagesBlock)">
          {{totalPagesBlock}}
        </div>
        <div class="page-end pagiItem" (click)="gotoNextPage()">Sau</div>
        <button nz-popover [nzPopoverTitle]="('toi_da' | translate) + ' ' +  totalPagesBlock" [nzPopoverContent]="contentTemplate"
          class="page-go pagiItem" nzPopoverPlacement="top">
          {{'toi_trang' | translate }}
        </button>
        <!-- Số lượng danh mục trên/trang -->
        <nz-select [nzSize]="'large'"
          [(ngModel)]="limitBlock"
          (ngModelChange)="handleChangeLimitBlock()"
          nzPlaceHolder=""
          nzAllowClear="false"
          class="ml-2">
          <nz-option *ngFor="let n of numberPerPage" [nzValue]="n" [nzLabel]="n + '/Trang'"></nz-option>
        </nz-select>
      </div>
      <ng-template #contentTemplate>
        <div class="input-container">
          <div class="input-group">
            <input class="form-control" width="10rem" placeholder="{{'nhap_trang_can_toi' | translate }}" type="number" min="1" [max]="totalPagesBlock" 
              [(ngModel)]="pageGoto" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button"
                (click)="transferFn(pageGoto > totalPagesBlock ? totalPagesBlock : pageGoto < 1 ? 1 : pageGoto)">
                {{'toi' | translate}}
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</nz-layout>


<!-- MODAL CHỌN SẢN PHẨM VÀO BLOCK -->
<nz-modal nzWidth="70vw" [(nzVisible)]="isShowModal" nzTitle="{{'chon' | translate}} {{name_main_sector | translate}} {{'hien_thi_trong_khung_tu_chon' | translate}}"
  (nzOnCancel)="isShowModal = false" (nzOnOk)="isShowModal = false">
  <ng-container *nzModalContent>
    <!-- Phần header -->
    <div class="row p-8 pt-0" style="padding: 15px;">
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-between">
        <span class="title"><b>{{'danh_sach' | translate}} {{name_main_sector | translate}}</b></span>
        <!-- Tìm kiếm -->
        <div class="search">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input placeholder="{{'tim_kiem_ten'| translate}} {{name_main_sector | translate}}"
              [(ngModel)]="searchNameObjectModal" (keyup.enter)="onSearchModal(searchNameObjectModal)" />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span (click)="onSearchModal(searchNameObjectModal)" nz-icon nzType="search"></span>
          </ng-template>
        </div>
        <!-- Chọn ngôn ngữ -->
        <!-- <div class="ml-2">
          <app-select-language-config [isAdmin]="true"></app-select-language-config>
        </div> -->
      </div>
      <!-- Chọn danh mục -->
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-end select">
        <nz-select style="margin: 0 16px; width: 18rem;" [(ngModel)]="id_category"
          nzPlaceHolder="{{'chon_danh_muc' | translate}} {{name_main_sector}}" (ngModelChange)="handleChangeCategoryFilterModal()">
          <nz-option [nzLabel]="'tat_ca' | translate" nzValue="all"></nz-option>
          <nz-option *ngFor="let item of categories" [nzValue]="item._id"
            [nzLabel]="item.array_step? generateSymBol(item.array_step) + (item['name_' + functionService.defaultLanguage] ?? '') || item.title : (item['name_' + functionService.defaultLanguage] ?? '') || item.title"></nz-option>
        </nz-select>
        <button class="_btn _btn_soft d-flex align-items-center right-all-content mr-2" nz-button nzType="default"
          (click)="resetPaginationModal();sortProductsModal()">
          {{'xem' | translate}}
        </button>
      </div>
    </div>
    <!-- Phần table -->
    <nz-table style="min-height: 450px; max-height: 450px;" 
      [nzLoading]="loadingObjectModal" 
      [nzScroll]="{ y: '350px' }" 
      [nzData]="searchedObjectsModal"
      #searchedObjectsModalTable 
      nzShowSizeChanger 
      [nzShowPagination]="false"
      [nzFrontPagination]="false">
      <!-- table header -->
      <thead class="_thead">
        <tr>
          <th nzWidth="10%" nzAlign="center"><b>{{'anh' | translate}}</b></th>
          <th nzWidth="65%" nzAlign="left">
            <b>{{'ten' | translate}} {{name_main_sector | translate}}</b>
            <span nz-icon nzTheme="outline" 
              (click)="handleSortModal()" 
              [nzType]=" isASCModal ? 'arrow-down' : 'arrow-up'">
            </span>
          </th>
          <th nzWidth="25%" nzAlign="center"><b>{{'an_hien' | translate}}</b></th>
        </tr>
      </thead>
      <!-- table body -->
      <tbody>
        <ng-container *ngFor="let item of searchedObjectsModalTable.data">
          <tr *ngIf="item.type">
            <td>
              <div class="image d-flex align-items-center justify-content-center">
                <img onerror="this.src='/assets/root/images/system/icons/image_default.svg'"
                  [src]="item.imgs? item.imgs[0] : ''" [alt]="(item['name_' + functionService.defaultLanguage] ?? '') || item.title" width="40px" height="40px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px; font-weight: 600;">
                <span>{{ (item['name_' + functionService.defaultLanguage] ?? '') || item.title }}</span>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status">
                <label class="switch">
                  <nz-switch [(ngModel)]="item[this.data._id+'_hidden']" (ngModelChange)="updateShowWeb(item,$event)"
                    [nzDisabled]="item[this.data._id+'_hidden']"></nz-switch>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>

    <!-- Pagination Modal -->
    <div *ngIf="searchedObjectsModal.length" class="pagination mt-3">
      <div class="pagination-list-button">
        <div class="page-start pagiItem" (click)="gotoPreviousPageModal()">{{'truoc' | translate }}</div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal >= 3 && pageCurrentModal >= 3" (click)="transferFnModal(1)">
          1
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal > 3 && pageCurrentModal > 3">
          ...
        </div>
        <div *ngFor='let page of pageShowChooseModal ;let i = index'>
          <div class="page-number pagiItem" *ngIf="page <= totalPagesModal && page > 0"
            [ngClass]="{'active': page == pageCurrentModal}" (click)="transferFnModal(page)">
            {{page}}
          </div>
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal > 3 && pageCurrentModal < totalPagesModal-2">
          ...
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal >= 3 && pageCurrentModal <= totalPagesModal-2"
          (click)="transferFnModal(totalPagesModal)">
          {{totalPagesModal}}
        </div>
        <div class="page-end pagiItem" (click)="gotoNextPageModal()">Sau</div>
        <button nz-popover [nzPopoverTitle]="'Tối đa ' +  totalPagesModal" [nzPopoverContent]="contentTemplate"
          class="page-go pagiItem" nzPopoverPlacement="top">
          {{'toi_trang' | translate }}
        </button>
        <!-- Số lượng danh mục trên/trang -->
        <nz-select [nzSize]="'large'"
          [(ngModel)]="limitModal"
          (ngModelChange)="handleChangeLimitModal()"
          nzPlaceHolder=""
          nzAllowClear="false"
          class="ml-2">
          <nz-option *ngFor="let n of numberPerPage" [nzValue]="n" [nzLabel]="n + '/Trang'"></nz-option>
        </nz-select>
      </div>
      <ng-template #contentTemplate>
        <div class="input-container">
          <div class="input-group">
            <input class="form-control" width="10rem" placeholder="{{'nhap_trang_can_toi' | translate }}" type="number" min="1" [max]="totalPagesModal" 
              [(ngModel)]="pageGoto" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button"
                (click)="transferFnModal(pageGoto > totalPagesModal ? totalPagesModal : pageGoto < 1 ? 1 : pageGoto)">
                {{'toi_trang' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</nz-modal>